<template>
  <el-dialog
    v-if="dialogVisible"
    class="expansion-create-channel-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :label-position="position"
      :rules="rules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="通道名称" prop="chanName">
        <el-input v-model="dataForm.chanName"></el-input>
      </el-form-item>

      <el-form-item label="质押金额" prop="balance">
        <el-input v-model="dataForm.balance"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleCreateChan()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'CreateChannel',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  props: {
    userId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      orgOptions: [], //组织
      userOptions: [], //用户列表
      nodeList: [], //节点列表
      orgId: '',
      title: '创建通道',
      position: 'right',
      dataForm: {
        chanName: '', //通道名称
        balance: null,
        userId: null
      },
      rules: {
        chanName: [
          { required: true, message: '请输入通道名称', trigger: ['change', 'blur'] },
          { pattern: /^[A-Za-z0-9]+$/, message: '只能输入英文和数字', trigger: ['change', 'blur'] }
        ],
        balance: [
          { required: true, message: '请输入质押金额', trigger: ['change', 'blur'] },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: ['change', 'blur'] }
        ]
      },
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {},
  methods: {
    //创建扩容节点
    handleCreateChan() {
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          this.disabled = true
          //获取form数据
          this.dataForm.userId = this.userId
          this.dataForm.chanName = this.dataForm.chanName
          this.dataForm.balance = Number(this.dataForm.balance)
          this.$apis.expansionDemo
            .createChan(this.dataForm)
            .then(res => {
              if (res) {
                this.$message.success('创建通道成功')
                this.$emit('createChannelSuccess')
                this.handleCancel()
              }
              this.disabled = false
            })
            .catch(err => {
              this.disabled = false
            })
        } else {
          this.$message.warning('请完善信息')
          this.disabled = false
          return
        }
      })
    },
    handleCancel() {
      this.dialogVisible = false
      this.disabled = false
      this.$refs.dataForm.resetFields()
    },
    handleOpen(data) {
      this.dataForm = {
        chanName: '', //通道名称
        balance: null,
        userId: null
      }
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.expansion-create-channel-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-select {
      width: 100%;
    }

    /deep/ .el-form-item__content {
      display: flex;
    }
  }
}
</style>
